<template>
  <ins
    class="adsbygoogle"
    style="display:block"
    data-ad-format="autorelaxed"
    data-ad-client="ca-pub-5453692719230487"
    data-ad-slot="7325390784"
  ></ins>
</template>

<script
  setup
  lang="ts"
>
import { loadScript } from '~/helpers/helpers';

onMounted(() => {
  loadScript("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5453692719230487", true, "anonymous")
    .then(() => {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });
})

</script>
